import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { id: "auth-v1" }
const _hoisted_2 = {
  class: "rel",
  style: {"padding":"30px 20px","height":"280px"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: "mb_30",
  style: {"font-size":"20px"}
}
const _hoisted_5 = { style: {"height":"100px","font-weight":"600"} }
const _hoisted_6 = { class: "text-ct" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "mb_30",
  style: {"font-size":"20px"}
}
const _hoisted_9 = { class: "mb_10" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "flex"
}
const _hoisted_12 = { style: {"line-height":"32px"} }
const _hoisted_13 = { class: "rel" }
const _hoisted_14 = { class: "mt_5" }
const _hoisted_15 = { class: "flex-cen" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  class: "mt_40 text-ct",
  style: {"font-size":"20px"}
}
const _hoisted_18 = { class: "text-ct" }

import fromPublicApp, { authStatus, AuthStatusEnum, authQuery } from '@/util/publicAuth'
import { computed, ref, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message, t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { authCafe24 } from '@/apis/user'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()

const redirect = encodeURIComponent(location.href)

const visible = computed({
  get: () => {
    return !!authStatus.value
  },
  set: (v) => {
    authStatus.value = ''
  }
})

const type = ref(1)
const radioOptions = [{ label: 0, text: t('选择店铺') }, { label: 1, text: t('创建店铺') }]

const shopId = ref('')
const shops = computed(() =>
  // 找到对应平台的店铺
  store.getters.user.customerShopList.filter((v:any) => {
    return v.authStatus === '0' && v.shopPlatform.toString() === fromPublicApp.APP[authQuery.value.state]
  }
  )
)

const shopname = ref('')

const loading = ref(false)

const auth = () => {
  const query:any = authQuery.value
  const params:any = {
    code: query.code,
    thirdShopId: query.thirdShopId,
    customerShopId: query.customerShopId
  }
  // url不带有shopId的情况
  if (!params.customerShopId) {
    if (type.value === 0 && !shopId.value) return ElMessage.error(t('请选择或创建一个CKB店铺进行授权'))
    if (type.value === 1 && !shopname.value) return ElMessage.error(t('请输入店铺名称'))
    //
    if (type.value === 0) {
      params.customerShopId = shopId.value
    } else {
      params.customerShopName = shopname.value
    }
  }
  authCafe24(params).then(res => {
    if (res.success) {
      authStatus.value = AuthStatusEnum.bindSuccess
      store.commit('route/curShop', res.data)
    }
  }).catch(res => {
    authQuery.value.customerShopId = null
  })
}

watchEffect(() => {
  if (authStatus.value === AuthStatusEnum.binding && authQuery.value?.customerShopId) auth()
})

const onSuccess = async () => {
  authStatus.value = AuthStatusEnum.hidden
  await store.dispatch('route/updateUser')
  const { query, ...rest } = route
  router.replace(rest)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _unref(visible),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      width: "600px",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      top: "20vh"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          (_unref(authStatus)===_unref(AuthStatusEnum).beforeBind)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('欢迎使用CKB应用')), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('请注册/登录后进行授权')), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_button, {
                      class: "mb_20",
                      style: {"font-size":"12px","width":"160px"},
                      type: "primary",
                      size: "large",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/login?redirect='+ _unref(redirect))))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('登录并授权')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_router_link, {
                    to: '/signup?redirect='+_unref(redirect),
                    style: {"font-size":"12px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('没有账号，点击创建')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(authStatus)===_unref(AuthStatusEnum).binding)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (!_unref(authQuery).customerShopId)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('欢迎使用CKB应用')), 1),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('请选择或创建一个CKB店铺进行授权')), 1),
                      (_unref(shops).length>0)
                        ? (_openBlock(), _createBlock(_component_el_radio_group, {
                            key: 0,
                            modelValue: type.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((type).value = $event)),
                            class: "ml_4"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(radioOptions, (v) => {
                                return _createVNode(_component_el_radio, {
                                  key: v.label,
                                  label: v.label,
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(v.text), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"])
                              }), 64))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (!type.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(_unref(t)('店铺')) + ": ", 1),
                            _createVNode(_component_el_select, {
                              modelValue: shopId.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shopId).value = $event)),
                              placeholder: _unref(t)('请选择或创建一个CKB店铺进行授权')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shops), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.customerShopId,
                                    label: item.customerShopName,
                                    value: item.customerShopId
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('请输入店铺名称')) + "：", 1),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_el_input, {
                                modelValue: shopname.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shopname).value = $event)),
                                style: {"width":"200px"}
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('将会为您创建CKB店铺并与{app}进行绑定').replace('{app}','Cafe24')), 1)
                            ])
                          ])),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_el_button, {
                          class: "abs",
                          style: {"bottom":"20px","font-size":"12px","width":"160px"},
                          type: "primary",
                          size: "large",
                          onClick: auth
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('授权')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(authStatus)===_unref(AuthStatusEnum).bindSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('恭喜您授权成功，请开始使用CKB吧')), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_button, {
                    style: {"margin-top":"100px","font-size":"12px","width":"160px"},
                    type: "primary",
                    size: "large",
                    onClick: onSuccess
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})